import { api } from './client'

// GET /api/v1/nav/badges — angka "menunggu tindakan" di menu sidebar admin.
// Balasan: { badges: { 'cert-send': n, 'doc-library': n, penilaian: n } }.
// Peran non-admin mendapat { badges: {} }.
export const getNavBadges = ({ programId, classId } = {}) =>
  api
    .get('/nav/badges', {
      params: {
        ...(programId ? { program_id: programId } : {}),
        ...(classId ? { class_id: classId } : {}),
      },
    })
    .then((r) => r.data.badges || {})
